import React, { useState } from 'react';
import { Typography } from '@material-ui/core';

import { useTranslation } from 'react-i18next';
import useApp from 'reducers/hooks/useApp';
import UserPresenter from 'presenters/UserPresenter';
import Seo from 'sharedComponents/Seo';
import { apiErrorsToFormik, getServerError } from 'utils/errors';

import Loader from 'sharedComponents/Loader';
import Alert from 'sharedComponents/Alert';
import { initialValues, validationSchema } from 'forms/updatePasswordForm';
import OptionalInfoFrom from './components/OptionalInfoForm';
import UpdatePasswordForm from './components/UpdatePasswordForm';
import useStyles from './useStyles';

const BuyerSettings = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { updatePassword, updateBuyer, isUpdating, currentUser, isPasswordUpdating } = useApp();
  const [isShowAlert, setShowAlert] = useState(false);

  const isLoading = isPasswordUpdating || isUpdating;

  const handleCloseAlert = () => {
    setShowAlert(false);
  };

  const handleSubmitUpdatePassword = async (values, { setErrors, setValues }) => {
    try {
      await updatePassword(values);
      setValues(initialValues, false);
      setShowAlert(true);
    } catch (error) {
      const { fullMessages } = apiErrorsToFormik(error);
      setErrors({ currentPassword: fullMessages });
    }
  };

  const handleSubmitOptionalInfo = async (values, { setErrors }) => {
    try {
      const attr = UserPresenter.buildUserUpdateAttributes(currentUser, values);
      await updateBuyer(attr);
    } catch (error) {
      const message = getServerError(error);
      setErrors({ email: message });
    }
  };

  return (
    <div className={classes.container}>
      <Seo title={t('meta.BuyerSettings.title')} description={t('meta.BuyerSettings.description')} />
      <div className={classes.content}>
        <Typography variant="h1" className={classes.header}>
          {t('components.BuyerSettings.header')}
        </Typography>
        <div className={classes.forms}>
          <div className={classes.form}>
            <OptionalInfoFrom onSubmit={handleSubmitOptionalInfo} currentUser={currentUser} />
          </div>
          {UserPresenter.isEmailProvider(currentUser) && (
            <div className={classes.form}>
              <UpdatePasswordForm
                onSubmit={handleSubmitUpdatePassword}
                initialValues={initialValues}
                validationSchema={validationSchema}
              />
            </div>
          )}
        </div>
        {isLoading && (
          <div className={classes.loaderContainer}>
            <Loader />
          </div>
        )}
      </div>
      <Alert
        text={t('components.UpdatePasswordForm.alert.success')}
        open={isShowAlert}
        handleClose={handleCloseAlert}
      />
    </div>
  );
};

export default BuyerSettings;



// WEBPACK FOOTER //
// ./src/components/BuyerSettings/BuyerSettings.js